import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Detalhes da Conciliação", -1)
const _hoisted_2 = { class: "flex flex-col gap-6 text-left" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary" }, "Linhas conciliadas automaticamente", -1)
const _hoisted_5 = { class: "flex items-center gap-3 min-w-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-positive bg-positive/10 rounded-full px-2 py-1 shrink-0" }, " Conciliado automaticamente ", -1)
const _hoisted_7 = { class: "text-sm text-textPrimary truncate" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-3" }, "Informações da folha", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-3" }, "Melhor candidato", -1)
const _hoisted_12 = { class: "flex flex-col lg:flex-row gap-6" }
const _hoisted_13 = { class: "w-full lg:w-1/2 min-w-0" }
const _hoisted_14 = { class: "lg:w-56 flex flex-col gap-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-textPrimary" }, " Essa vaga corresponde com a linha indicada do registro? ", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "text-sm text-textPrimary mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-textPrimary mb-3" }, "Melhores candidatos:", -1)
const _hoisted_19 = ["data-testid", "onClick"]
const _hoisted_20 = { class: "flex flex-col gap-1 min-w-0 flex-1" }
const _hoisted_21 = {
  key: 0,
  "data-testid": "conciliation-candidate-recommended-badge",
  class: "text-xs font-bold text-primary bg-primary/10 rounded-full px-2 py-1 shrink-0 self-start"
}
const _hoisted_22 = {
  key: 2,
  class: "flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-red-700 mb-1" }, "Nenhum plantão encontrado"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-600" }, " Não foi possível encontrar um plantão correspondente para este registro. Você pode avançar sem conciliar esta linha. ")
], -1)
const _hoisted_24 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" }
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-neutral50"
}
const _hoisted_26 = {
  key: 1,
  class: "text-sm text-neutral50"
}
const _hoisted_27 = { class: "flex flex-col sm:flex-row gap-3" }

import { ref, computed, watch } from 'vue'
import { addHours, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { mdiCheckboxMarked, mdiCheckboxBlankOutline, mdiAlertCircleOutline } from '@mdi/js'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import DsAttendanceInfoSheetsCard from '@/components/designSystem/Cards/DsAttendanceInfoSheetsCard.vue'
import type { DsAttendanceInfoRow } from '@/components/designSystem/Cards/DsAttendanceInfoSheetsCard.vue'
import CardBestCandidate from '@/components/designSystem/Cards/CardBestCandidate.vue'
import NetworkService from '@/Network/index'
import type { DoctorStationObservationListResponse } from '@/Network/Types/Responses/DsObservationResponse'
import { mapCandidateToCardProps } from '../utils/conciliation-candidate'
import type { DSAttendanceConciliateRowResult } from '@/Network/Types/Responses/DsAttendancePolicyResponses'

const NOT_INFORMED = 'Não informado'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceConciliationModal',
  props: {
    modelValue: { type: Boolean },
    rows: { default: () => [] },
    preConfirmedRows: { default: () => [] },
    undoingEntryId: { default: null },
    sheetRows: { default: () => [] },
    confirmed: { type: Boolean, default: false },
    hideSignatureColumns: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "confirm", "undo"],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * BUG-02/QW-02 — o backend já ranqueia os candidatos de uma linha MULTIPLE_MATCHES e marca
 * `isRecommended` no melhor (proximidade de checkin/checkout). Pré-selecionar aqui só
 * materializa a recomendação na tela: o auditor continua livre para trocar antes de
 * confirmar — nenhuma seleção é enviada sem passar por "Próxima vaga"/"Concluir".
 */
function preselectRecommendedCandidate(row: DSAttendanceConciliateRowResult | null): string | null {
  if (!row || row.matchStatus !== 'MULTIPLE_MATCHES') return null
  const recommendedIndex = row.candidates.findIndex((c) => c.isRecommended)
  return recommendedIndex >= 0 ? String(recommendedIndex) : null
}

const currentIndex = ref(0)
const singleMatchAnswer = ref<'yes' | 'no' | null>(null)
const currentMultipleSelection = ref<string | null>(
  preselectRecommendedCandidate(props.rows[0] ?? null)
)
const selections = ref<Record<number, number>>({})
const isSubmitting = ref(false)

const observations = ref<DoctorStationObservationListResponse>({ data: [], count: 0 })

const currentRow = computed(() => props.rows[currentIndex.value] ?? null)
// Sem linhas pendentes (todas pré-confirmadas), o footer libera "Concluir" direto — sem isso
// o botão ficaria preso em "Próxima vaga" incrementando um índice que nunca fecha o modal.
const isLastSlot = computed(
  () => props.rows.length === 0 || currentIndex.value === props.rows.length - 1
)

const isNextDisabled = computed(() => {
  if (!currentRow.value) return false

  const matchStatus = currentRow.value.matchStatus

  if (matchStatus === 'SINGLE_MATCH' && currentRow.value.candidates.length > 0) {
    return singleMatchAnswer.value === null
  }

  if (matchStatus === 'MULTIPLE_MATCHES') {
    return currentMultipleSelection.value === null
  }

  return false
})

function formatTime(isoString: string | null | undefined): string {
  if (!isoString) return '-'
  return format(new Date(isoString), 'HH:mm')
}

function getSheetValue(
  row: Record<string, string | boolean>,
  normalizedTarget: string
): string | boolean | undefined {
  return Object.entries(row).find(([key]) => {
    const normalized = key.normalize('NFD').replace(/\p{Diacritic}/gu, '')
    return normalized === normalizedTarget
  })?.[1]
}

function extractSheetFields(rowIndex: number) {
  const sheetRow = props.sheetRows[rowIndex]
  if (!sheetRow) {
    return { time: '-', entrySignature: false, exitSignature: false }
  }
  const journeyStart = getSheetValue(sheetRow, 'jornada_inicio')
  const journeyEnd = getSheetValue(sheetRow, 'jornada_fim')
  return {
    time: journeyStart && journeyEnd ? `${journeyStart} - ${journeyEnd}` : '-',
    entrySignature: !!getSheetValue(sheetRow, 'ass._e_carimbo_entrada'),
    exitSignature: !!getSheetValue(sheetRow, 'ass._e_carimbo_saida')
  }
}

function buildAttendanceInfo(row: DSAttendanceConciliateRowResult): DsAttendanceInfoRow {
  const checkin = row.checkinReal ? new Date(row.checkinReal) : null
  const { time, entrySignature, exitSignature } = extractSheetFields(row.rowIndex)

  return {
    doctorName: row.rawDoctorName?.toUpperCase() ?? '-',
    crm: row.rawCrm ?? '-',
    date: checkin ? format(checkin, 'dd/MM/yyyy') : '-',
    time,
    station: '-',
    entryTime: formatTime(row.checkinReal),
    entrySignature,
    exitTime: formatTime(row.checkoutReal),
    exitSignature
  }
}

const currentAttendanceInfo = computed<DsAttendanceInfoRow>(() => {
  const row = currentRow.value
  return row ? buildAttendanceInfo(row) : emptyAttendanceInfo()
})

watch(
  () => props.modelValue,
  (val) => {
    if (val && !props.confirmed) {
      currentIndex.value = 0
      singleMatchAnswer.value = null
      currentMultipleSelection.value = preselectRecommendedCandidate(props.rows[0] ?? null)
      selections.value = {}
      isSubmitting.value = false
    }
  }
)

watch(currentIndex, () => {
  if (props.confirmed) {
    const row = currentRow.value
    if (row?.matchStatus === 'SINGLE_MATCH') {
      singleMatchAnswer.value = selections.value[row.rowIndex] ? 'yes' : 'no'
    } else if (row?.matchStatus === 'MULTIPLE_MATCHES') {
      const savedId = selections.value[row.rowIndex]
      const idx = savedId ? row.candidates.findIndex((c) => c.doctorStationId === savedId) : -1
      currentMultipleSelection.value = idx >= 0 ? String(idx) : 'none'
    } else {
      singleMatchAnswer.value = null
      currentMultipleSelection.value = null
    }
  } else {
    singleMatchAnswer.value = null
    currentMultipleSelection.value = preselectRecommendedCandidate(currentRow.value)
  }
})

async function fetchObservations(doctorStationId: number) {
  try {
    observations.value = await NetworkService.observation.list(doctorStationId)
  } catch {
    observations.value = { data: [], count: 0 }
  }
}

watch(
  currentRow,
  (row) => {
    observations.value = { data: [], count: 0 }
    if (row?.matchStatus === 'SINGLE_MATCH' && row.candidates.length > 0) {
      fetchObservations(row.candidates[0].doctorStationId)
    }
  },
  { immediate: true }
)

watch(currentMultipleSelection, (sel) => {
  const row = currentRow.value
  if (!row || row.matchStatus !== 'MULTIPLE_MATCHES' || sel === null || sel === 'none') {
    observations.value = { data: [], count: 0 }
    return
  }
  const idx = Number(sel)
  if (!isNaN(idx) && row.candidates[idx]) {
    fetchObservations(row.candidates[idx].doctorStationId)
  }
})

const formattedObservations = computed(() =>
  observations.value.data.map((obs) => {
    let correctedTimestamp = 'Data inválida'
    if (obs.createdAt) {
      try {
        const utcDate = new Date(obs.createdAt)
        const timezone = obs.doctorStation?.timezone || '-03:00'
        const offsetHours = parseInt(timezone.split(':')[0], 10)
        const localDate = addHours(utcDate, offsetHours)
        correctedTimestamp = format(localDate, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
      } catch {
        correctedTimestamp = 'Data inválida'
      }
    }
    return {
      author: obs.author.name,
      timestamp: correctedTimestamp,
      text: obs.text
    }
  })
)

function emptyAttendanceInfo(): DsAttendanceInfoRow {
  return {
    doctorName: '-',
    crm: '-',
    date: '-',
    time: '-',
    station: '-',
    entryTime: '-',
    entrySignature: false,
    exitTime: '-',
    exitSignature: false
  }
}

/** QW-01/28-06 — rótulo do médico + vaga casada para a linha pré-confirmada (badge). */
function buildPreConfirmedLabel(row: DSAttendanceConciliateRowResult): string {
  const candidate = row.candidates.find((c) => c.doctorStationId === row.doctorStationId)
  const doctorName = row.rawDoctorName?.toUpperCase() ?? NOT_INFORMED
  if (!candidate) {
    return `${doctorName} — Vaga #${row.doctorStationId ?? '-'}`
  }
  const breadcrumb = [
    candidate.company?.name,
    candidate.healthUnit?.name,
    candidate.sector?.name,
    candidate.position?.name
  ]
    .filter(Boolean)
    .join(' > ')
  return `${doctorName} — ${breadcrumb}`
}

function accumulateCurrentSelection() {
  const row = currentRow.value
  if (!row) return

  if (row.matchStatus === 'SINGLE_MATCH' && row.candidates.length > 0) {
    if (singleMatchAnswer.value === 'yes') {
      selections.value[row.rowIndex] = row.candidates[0].doctorStationId
    } else {
      delete selections.value[row.rowIndex]
    }
  } else if (row.matchStatus === 'MULTIPLE_MATCHES') {
    if (currentMultipleSelection.value === 'none') {
      delete selections.value[row.rowIndex]
    } else {
      const idx = Number(currentMultipleSelection.value)
      if (!isNaN(idx) && row.candidates[idx]) {
        selections.value[row.rowIndex] = row.candidates[idx].doctorStationId
      }
    }
  }
}

function handleNext() {
  accumulateCurrentSelection()
  if (isLastSlot.value) {
    if (isSubmitting.value) return
    isSubmitting.value = true
    emit('confirm', { ...selections.value })
    emit('update:modelValue', false)
  } else {
    currentIndex.value++
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[80vw]",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_24, [
        (_ctx.rows.length > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Conciliação de vaga " + _toDisplayString(currentIndex.value + 1) + "/" + _toDisplayString(_ctx.rows.length), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_26, " Nenhuma linha pendente de revisão manual ")),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(OutlineButton, {
            text: "Voltar",
            class: "w-full sm:w-auto",
            width: "96px",
            height: "40px",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
          }),
          _createVNode(FilledButton, {
            text: isLastSlot.value ? 'Concluir' : 'Próxima vaga',
            class: "w-full sm:w-auto bg-primary30",
            width: "140px",
            height: "40px",
            disabled: isNextDisabled.value || (isLastSlot.value && isSubmitting.value),
            onClick: handleNext
          }, null, 8, ["text", "disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.preConfirmedRows.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preConfirmedRows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.entryId,
                  "data-testid": "pre-confirmed-conciliation-row",
                  class: "flex items-center justify-between gap-3 border border-lightGray30 rounded-xl p-3"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createElementVNode("span", _hoisted_7, _toDisplayString(buildPreConfirmedLabel(row)), 1)
                  ]),
                  _createVNode(OutlineButton, {
                    text: "Desfazer",
                    "data-testid": "undo-automatic-conciliation-button",
                    width: "96px",
                    height: "32px",
                    class: "shrink-0",
                    disabled: _ctx.undoingEntryId === row.entryId,
                    onClick: ($event: any) => (emit('undo', row.entryId))
                  }, null, 8, ["disabled", "onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (currentRow.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _createVNode(DsAttendanceInfoSheetsCard, {
                  items: [currentAttendanceInfo.value],
                  "hide-signature-columns": _ctx.hideSignatureColumns
                }, null, 8, ["items", "hide-signature-columns"])
              ]),
              (currentRow.value.matchStatus === 'SINGLE_MATCH' && currentRow.value.candidates.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(CardBestCandidate, _mergeProps(_unref(mapCandidateToCardProps)(currentRow.value.candidates[0]), {
                          observations: formattedObservations.value,
                          active: ""
                        }), null, 16, ["observations"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode(_component_v_radio_group, {
                          modelValue: singleMatchAnswer.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((singleMatchAnswer).value = $event)),
                          "hide-details": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              label: "Sim",
                              value: "yes",
                              color: "primary"
                            }),
                            _createVNode(_component_v_radio, {
                              label: "Não",
                              value: "no",
                              color: "primary"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : (currentRow.value.matchStatus === 'MULTIPLE_MATCHES')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(currentRow.value.matchMessage ??
              'Vários candidatos encontrados. Selecione um para continuar a conciliação.'), 1),
                      _createVNode(_component_v_radio_group, {
                        modelValue: currentMultipleSelection.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentMultipleSelection).value = $event)),
                        "hide-details": "",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            label: "Nenhum dos candidatos abaixo corresponde à linha do registro",
                            value: "none"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_18,
                      _createElementVNode("div", {
                        class: _normalizeClass(
              currentRow.value.candidates.length <= 2
                ? 'grid grid-cols-2 gap-4'
                : 'flex gap-4 overflow-x-auto pb-2'
            )
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentRow.value.candidates, (candidate, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            "data-testid": `conciliation-candidate-${index}`,
                            class: _normalizeClass(["flex items-start gap-2 cursor-pointer", currentRow.value.candidates.length > 2 ? 'min-w-[380px] max-w-[420px]' : '']),
                            onClick: ($event: any) => (currentMultipleSelection.value = String(index))
                          }, [
                            _createVNode(_component_v_icon, {
                              icon: 
                  currentMultipleSelection.value === String(index)
                    ? _unref(mdiCheckboxMarked)
                    : _unref(mdiCheckboxBlankOutline)
                ,
                              color: currentMultipleSelection.value === String(index) ? 'primary' : '#BCBCCD',
                              size: "22",
                              class: "mt-1 shrink-0"
                            }, null, 8, ["icon", "color"]),
                            _createElementVNode("div", _hoisted_20, [
                              (candidate.isRecommended)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " Sugerido "))
                                : _createCommentVNode("", true),
                              _createVNode(CardBestCandidate, _mergeProps(_unref(mapCandidateToCardProps)(candidate), {
                                observations: 
                    currentMultipleSelection.value === String(index) ? formattedObservations.value : []
                  ,
                                active: currentMultipleSelection.value === String(index)
                              }), null, 16, ["observations", "active"])
                            ])
                          ], 10, _hoisted_19))
                        }), 128))
                      ], 2)
                    ]))
                  : (currentRow.value.matchStatus === 'NO_MATCH')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_v_icon, {
                          icon: _unref(mdiAlertCircleOutline),
                          color: "red",
                          size: "24",
                          class: "shrink-0 mt-0.5"
                        }, null, 8, ["icon"]),
                        _hoisted_23
                      ]))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})